// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mobile-drawer-logo[data-v-3171b9c2] {\n  height: 64px;\n}\n.active-item[data-v-3171b9c2] {\n  background: #0d47a1;\n  color: white !important;\n}\n#notice[data-v-3171b9c2] {\n  position: absolute;\n  bottom: 12px;\n  left: 12px;\n}\n.submenu-item[data-v-3171b9c2] {\n  padding-left: 48px !important;\n}\n.report-group .v-list-item__content[data-v-3171b9c2] {\n  margin-left: -15px;\n}\n", ""]);
// Exports
module.exports = exports;
